import { render, staticRenderFns } from "./SampleRequestAddNew.vue?vue&type=template&id=23dc1082&"
import script from "./SampleRequestAddNew.vue?vue&type=script&lang=js&"
export * from "./SampleRequestAddNew.vue?vue&type=script&lang=js&"
import style0 from "./SampleRequestAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports